import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import { BasicNodeLayout, NodeSize, NodeType, NodeTypeCategory } from "../Base";
import { DataType } from "../TypeDefinitions";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";
import { ObjectSchemaTags } from "../../FlowDocument/FlowDocumentModel";

const objectInput = "object";
const inputTagsProperty = "inputTags";
const schemaOverrideProperty = "overrideSchema";
const schemaOverrideNameProperty = "overrideSchemaName";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.objectProperties,
  label: "Fields",
  category: NodeTypeCategory.general,
  hideLabelOnAnchor: true,
  controlOutputs: [],
  dataInputs: [{ name: objectInput, type: DataType.OBJECT, hideLabel: true, required: false }],
  dataOutputs: [],
  documentDataOutputList: "properties",
  outputsSchemaProperties: true,
  nodeConfigProperties: [
    {
      name: inputTagsProperty,
      propertyType: NodeConfigPropertyType.ConnectedSchemaTags,
      options: { dataParams: [objectInput] }
    },
    {
      name: schemaOverrideProperty,
      label: "As Object",
      propertyType: NodeConfigPropertyType.Schema,
      options: {
        dataProperties: [objectInput],
        displayProperty: schemaOverrideNameProperty,
        excludeReferences: true
      },
      showOnPropertyValues: {
        propertyName: inputTagsProperty,
        propertyValues: [ObjectSchemaTags.dynamicObject]
      }
    },
    {
      name: schemaOverrideNameProperty,
      propertyType: NodeConfigPropertyType.NoInput
    },
    {
      name: "outputs",
      sectionName: "Output",
      propertyType: NodeConfigPropertyType.EnabledOutputs
    }
  ],
  size: NodeSize.Small,
  evaluate: (input, nodeProperties) => {
    let output: any = {};
    Object.keys(nodeProperties.outputs).forEach((outputName) => {
      if (nodeProperties.outputs[outputName].enabled) {
        output[outputName] = input[objectInput] ? (input[objectInput] as any)[outputName] : null;
      }
    });
    return { output: output, activeControlHandleIds: [] };
  }
});

export const ObjectPropertiesNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  const dynamic = data.nodeProperties[inputTagsProperty]?.includes(ObjectSchemaTags.dynamicObject);
  const label =
    dynamic && data.nodeProperties[schemaOverrideNameProperty]
      ? `As ${data.nodeProperties[schemaOverrideNameProperty]}`.substring(0, 20)
      : undefined;
  return (
    <BasicNodeLayout id={id} data={data}>
      <div className="dynamic-object-node-label">
        {label ? `As ${data.nodeProperties[schemaOverrideNameProperty]}` : null}
      </div>
    </BasicNodeLayout>
  );
};
